import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a shower icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <ShowerIcon width={24} />
 */
const ShowerIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M9 17C9 17.55 8.55 18 8 18C7.45 18 7 17.55 7 17C7 16.45 7.45 16 8 16C8.55 16 9
            16.45 9 17ZM12 16C11.45 16 11 16.45 11 17C11 17.55 11.45 18 12 18C12.55 18 13 17.55
            13 17C13 16.45 12.55 16 12 16ZM16 16C15.45 16 15 16.45 15 17C15 17.55 15.45 18 16 18C16.55
            18 17 17.55 17 17C17 16.45 16.55 16 16 16ZM8 19C7.45 19 7 19.45 7 20C7 20.55 7.45 21 8
            21C8.55 21 9 20.55 9 20C9 19.45 8.55 19 8 19ZM12 19C11.45 19 11 19.45 11 20C11 20.55 11.45
            21 12 21C12.55 21 13 20.55 13 20C13 19.45 12.55 19 12 19ZM16 19C15.45 19 15 19.45 15 20C15
            20.55 15.45 21 16 21C16.55 21 17 20.55 17 20C17 19.45 16.55 19 16 19ZM13 5.08V4C13 3.45 12.55
            3 12 3C11.45 3 11 3.45 11 4V5.08C7.62 5.57 5 8.49 5 12V13C5 13.55 5.45 14 6 14H18C18.55 14 19
            13.55 19 13V12C19 8.49 16.38 5.57 13 5.08Z`}
        />
    </SvgIcon>
)

ShowerIcon.defaultProps = defaultProps

export { ShowerIcon }
